<div class="header">
    <h2>Dettaglio <strong>Ispezione</strong></h2>
    <div class="breadcrumb-wrapper hidden-xs">
        <ol class="breadcrumb">
            <li><a style="cursor: pointer;" [routerLink]="['/inspection-general']">Gestione Ispezioni</a></li>
            <li class="active">Dettaglio Ispezione</li>
        </ol>
    </div>
</div>
<div class="row">
    <div class="col-md-4">
        <div class="panel">
            <div class="panel-header panel-controls bg-dark">
                <h3><i class="fa fa-list"></i>Informazioni <strong>Ispezione</strong></h3>
            </div>
            <div class="panel-content">
                <h4><i class="fa fa-info-circle"></i>
                    <strong>Stato:</strong> {{ (inspection.inspection_state?.value === 'Pianificata' && action === 'inspection') ? 'Da fare' : inspection.inspection_state?.value }}
                </h4>
                <h4><i class="fa fa-briefcase"></i> <strong>Convenzione:</strong>&nbsp;<a *ngIf="user.fk_id_role <= 1"
                        [routerLink]="['/contract/' + inspection?.contract?.id_contract]">{{ inspection?.contract?.name }}</a>
                    <span *ngIf="user.fk_id_role > 1">{{ inspection?.contract?.name }}</span>
                </h4>
                <h4 *ngIf="inspection?.user?.name !== null; else inspectorNull"><i class="fa fa-user"></i>
                    <strong>Ispettore:</strong> {{ inspection?.user?.name + ' ' + inspection?.user?.surname }}</h4>
                <ng-template #inspectorNull><h4><i class="fa fa-user"></i> <strong>Ispettore:</strong> -</h4>
                </ng-template>
                <h4><i class="fa fa-calendar"></i> <strong>Data di
                    Pianificazione:</strong> {{ inspection?.date | date: 'dd/MM/yyyy HH:mm' }}</h4>
                <h4><i class="fa fa-list-alt"></i> <strong>Ragione Sociale:</strong> {{ inspection?.pa?.name }}</h4>
                <h4><i class="fa fa-list-alt"></i>
                    <strong>Comparto:</strong> {{ inspection?.pa?.compartment | titlecase }}</h4>
                <h4><i class="fa fa-map-marker"></i>
                    <strong>Indirizzo:</strong> {{ inspection?.pa?.address + ' ' + inspection?.pa?.house_number}}</h4>
                <h4><i class="fa fa-map-marker"></i> <strong>CAP:</strong> {{ inspection?.pa?.cap }}</h4>
                <h4><i class="fa fa-location-arrow"></i> <strong>Comune
                    (Provincia):</strong> {{ inspection?.pa?.municipality + ' (' + inspection?.pa?.province + ')' }}
                </h4>
            </div>
            <div *ngIf="user.fk_id_role <= 1 || (user.fk_id_role === 2 && inspection.fk_id_user === user.id_user &&
            (inspection.inspection_state?.id_inspection_state === 3 || inspection.inspection_state?.id_inspection_state === 4))"
                 class="panel-footer">
                <a class="btn btn-primary"
                   *ngIf="user.fk_id_role === 2 &&
            inspection.fk_id_user === user.id_user &&
            (inspection.inspection_state?.id_inspection_state === 3 || inspection.inspection_state?.id_inspection_state === 4)"
                   [routerLink]="['/inspection/checklist/' + inspection.id_inspection]"><i class="fa fa-pencil"></i>
                    Compila</a>
                <a class="btn btn-blue" *ngIf="user.fk_id_role <= 1"
                   [routerLink]="['/inspection/update/' + inspection.id_inspection]"><i class="icon-pencil"></i>
                    Modifica</a>
                <a class="btn btn-danger"
                   *ngIf="user.fk_id_role <= 1"
                   (click)="openDeleteInspectionModal()"><i class="icon-trash"></i> Elimina</a>
            </div>
        </div>
    </div>
    <div class="col-md-8">
        <div class="row">
            <div class="col-md-12">
                <div id="panel-orders" class="panel">
                    <div class="panel-header panel-controls bg-dark">
                        <h3><i class="fa fa-list"></i><strong>Ordinativi</strong></h3>
                    </div>
                    <div class="panel-content table-responsive">
                        <table *ngIf="inspectionOrders.length > 0" class="table table-hover">
                            <thead>
                            <tr>
                                <th style="width: 10%;">Numero</th>
                                <th style="width: 30%;">Nome Referente</th>
                                <th style="width: 15%;">Telefono Referente</th>
                                <th style="width: 30%;">E-mail Referente</th>
                                <th style="width: 15%;">Azioni</th>
                            </tr>
                            </thead>
                            <tbody>
                            <tr *ngFor="let inspectionOrder of inspectionOrders">
                                <td>{{ inspectionOrder.number }}</td>
                                <td>{{ inspectionOrder.referent_name }}</td>
                                <td>{{ inspectionOrder.referent_phone }}</td>
                                <td>{{ inspectionOrder.referent_email }}</td>
                                <td>
                                    <a class="edit btn btn-sm btn-primary"
                                       [routerLink]="['/inspection/order/' + inspectionOrder.id_inspection_order]"
                                       mat-raised-button
                                       matTooltip="Dettaglio"
                                       matTooltipPosition="above">
                                        <i class="fa fa-info-circle"></i></a>
                                    <a *ngIf="user.fk_id_role <= 1" class="delete btn btn-sm btn-danger"
                                       (click)="openDeleteInspectionOrderModal(inspectionOrder)"
                                       mat-raised-button
                                       matTooltip="Elimina"
                                       matTooltipPosition="above">
                                        <i class="icons-office-57"></i>
                                    </a>
                                </td>
                            </tr>
                            </tbody>
                        </table>
                        <div *ngIf="inspectionOrders.length === 0" style="text-align: center; height: 150px; padding-top: 60px;">
                            Nessun ordinativo associato
                        </div>
                    </div>
                    <div *ngIf="user.fk_id_role <= 1" class="panel-footer" style="text-align: center;">
                        <a class="btn btn-success" [routerLink]="['/inspection/order/create/' + inspection.id_inspection]"><i
                                class="icon-plus"></i> Aggiungi</a>
                    </div>
                </div>
            </div>

            <div class="col-md-12">
                <div id="panel-documents" class="panel">
                    <div class="panel-header panel-controls bg-dark">
                        <h3><i class="fa fa-file"></i><strong>Documenti</strong></h3>
                    </div>
                    <div class="panel-content table-responsive">
                        <table *ngIf="inspectionDocuments.length > 0" class="table table-hover">
                            <thead>
                            <tr>
                                <th style="width: 85%;">Nome</th>
                                <th style="width: 15%;">Azioni</th>
                            </tr>
                            </thead>
                            <tbody>
                            <tr *ngFor="let inspectionDocument of inspectionDocuments">
                                <td>{{ inspectionDocument.name }}</td>
                                <td>
                                    <a class="edit btn btn-sm btn-primary"
                                       (click)="downloadInspectionDocument(inspectionDocument)"
                                       mat-raised-button
                                       matTooltip="Download"
                                       matTooltipPosition="above">
                                        <i class="fa fa-download"></i>
                                    </a>
                                    <a *ngIf="user.fk_id_role <= 1" class="delete btn btn-sm btn-danger"
                                       (click)="openDeleteInspectionDocumentModal(inspectionDocument)"
                                       mat-raised-button
                                       matTooltip="Elimina"
                                       matTooltipPosition="above">
                                        <i class="icons-office-57"></i>
                                    </a>
                                </td>
                            </tr>
                            </tbody>
                        </table>
                        <div *ngIf="inspectionDocuments.length === 0" style="text-align: center; height: 100px; padding-top: 35px;">
                            Nessun documento caricato
                        </div>
                    </div>
                    <div *ngIf="user.fk_id_role <= 1" class="panel-footer" style="text-align: center;">
                        <a class="btn btn-success" [routerLink]="['/inspection/document/create/' + inspection.id_inspection]"><i
                                class="icon-plus"></i> Aggiungi</a>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>
